export default {
  meta: {
    title: 'Notre équipe',
    description:
      'Le FEIA a veillé à constituer une équipe internationale et expérimentée, regroupant le monde des affaires, le secteur public et le milieu académique'
  },
  header: {
    title: 'Notre équipe',
    content:
      "La FEIA s'est attachée à constituer une équipe internationale et dynamique, forte d'une expérience acquise dans le monde des affaires, gouvernemental et académique."
  },
  cta: {
    title: "Faites partie de l'équipe",
    content: "L'organisation se développe rapidement et nous invitons les candidats intéressés à envoyer leur CV.",
    button: 'Envoyer mon CV'
  },
  members: [
    {
      name: 'Nicholas Rémillard',
      title: 'Chef de la direction',
      info: 'Forum économique international des Amériques',
      image: '/images/team/Nicholas_Remillard-2636_HR.jpg'
    },
    {
      name: 'Gil Rémillard',
      title: 'Président-fondateur',
      info: 'Forum économique international des Amériques',
      image: '/images/team/Gil_Remillard-2292_HR.jpg'
    },
    {
      name: 'Marie DuPont',
      title: 'Première conseillère financière',
      info: 'Forum économique international des Amériques',
      image: '/images/team/thumbnail-1.png'
    },
    {
      name: 'Thaïs Pinto',
      title: 'Présidente et cheffe des affaires juridiques',
      info: 'Forum économique international des Amériques',
      image: '/images/team/ThaisPinto.png'
    },
    {
      name: 'Mathieu Rondeau',
      title: 'Chef de la direction financière',
      info: 'Forum économique international des Amériques',
      image: '/images/team/MathieuRondeau.png'
    },
    {
      name: 'Alain Dufour',
      title: 'Vice-Président, Production et Expérience',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/AlainDufour.jpg'
    },
    {
      name: 'Francisca Insulza',
      title: 'Vice-présidente, relation avec les partenaires et croissance stratégique',
      info: 'Forum économique international des Amériques',
      image: '/images/team/FranciscaInsulza.jpg'
    },
    {
      name: 'Cédric Muller',
      title: 'Vice-président, contenu et affaires externes',
      info: 'Forum économique international des Amériques',
      image: '/images/team/CedrickMuller.jpg'
    },
    {
      name: 'Francesco Biondi-Morra di Belforte',
      title: 'Directeur, contenu et programmation',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/Francesco Biondi-Morra di Belforte.png'
    },
    {
      name: 'Éric Buchlin',
      title: 'Directeur Sureté',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/ericBuchlin.jpg'
    },
    {
      name: 'Rebecca Durnin',
      title: 'Directrice, Communication et Marketing',
      info: 'Forum économique international des Amériques',
      image: '/images/team/RebeccaDurnin.jpg'
    },
    {
      name: 'Rafael Moya Herrero',
      title: 'Conseiller principal, contenu et programmation',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/rafael-moya-herrero.jpg'
    },
    {
      name: 'Benjamin Booth',
      title: 'Conseiller exécutif ',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/benjamin-booth.JPG'
    },
    {
      name: 'Laure Duque',
      title: 'Chargée de projet participation et développement de communautés d’intérêt',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/LaureDuque.jpg'
    },
    {
      name: 'Myriam Tannous',
      title: 'Chargée de projet, communication et marketing',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/myriam-tannous.jpg'
    },
    {
      name: 'Noémie Baillarguet',
      title: 'Conseillère, marketing et communication',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/Noémie Baillarguet.jpg'
    },
    {
      name: 'Lyonel Millien',
      title: 'Contrôleur adjoint',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/lyonel-millien.jpg'
    },
    {
      name: 'Aurore Saccagi',
      title: 'Conseillère, contenu et programmation',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/aurore-saccagi.jpg'
    },
    {
      name: 'Virgile Sylvain',
      title: 'Conseiller, Relations avec les partenaires',
      info: 'Forum Économique International des Amériques',
      image: '/images/team/Virgile Sylvain.png'
    },
    {
      name: 'Joseph Clark',
      title: 'Président',
      info: 'Toronto Global Forum',
      image: '/images/team/JosephClark.jpg'
    },

    {
      name: 'Ali Ponte',
      title: 'Directeur exécutif',
      info: 'Toronto Global Forum',
      image: '/images/team/AliPonte.jpg'
    },
    {
      name: 'Bill Johnson',
      title: 'Président',
      info: 'World Strategic Forum',
      image: '/images/team/BillJohnson.png'
    },
    {
      name: 'Julia Bernstein',
      title: 'Directrice exécutive',
      info: 'World Strategic Forum',
      image: '/images/team/julia-bernstein.jpeg'
    },
    {
      name: 'Céline Boyard',
      title: 'Directrice exécutive',
      info: 'La Conférence de Paris',
      image: '/images/team/CelineBoyard.png'
    },
    {
      name: 'Dorothée Pineau',
      title: 'Conseillère pour les entreprises',
      info: 'La Conférence de Paris',
      image: '/images/team/DorothéePineau.jpg'
    }
  ]
}
